
import './styles.css';
import InsaneTable from '../../component/insane-table'

function ProductionChecksheetPlan() {
    const tableOption = {
        tableName: "Plant",
        className: "",
        search: [
            {
                reqName: "search_plantname",
                displayName: "Plant Name",
                element: "input",
                placeholder: "Enter Name."
            }
        ],
        mapTable: [
            {
                displayName: "ID",
                attName: "plantid",
                type: "text",
                form: {
                    validate: true,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Name",
                attName: "plantname",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Created By",
                attName: "createdbyuserid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Created Time",
                attName: "createdtime",
                type: "date",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/plant/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "search_plantname": "",
                    "search_tagid": ""
                }
            },
            insert: {
                enable: true,
                url: "/admin/pd/plant/update",
                dataReq: {
                    "plantname": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/pd/plant/update",
                dataReq: {
                    "plantid": "",
                    "plantname": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/pd/plant/delete",
                dataReq: {
                    "plantid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Plant Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default ProductionChecksheetPlan;